// src/components/DeliveryPolicy.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaTruck } from 'react-icons/fa';

const DeliveryPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <Link 
        to="/" 
        className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-6"
      >
        <FaArrowLeft /> Back to Home
      </Link>

      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <FaTruck className="text-2xl text-green-600" />
          <h1 className="text-3xl font-bold text-gray-800">Delivery Policy</h1>
        </div>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Delivery Areas</h2>
            <p className="text-gray-700 mb-4">
              We currently deliver to most metropolitan areas within our operating regions. 
              To check if we deliver to your area, please enter your postal code during checkout.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Delivery Timeframes</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Standard delivery:</strong> 2-3 business days</li>
              <li><strong>Express delivery:</strong> Next business day (orders placed before 2 PM)</li>
              <li><strong>Same-day delivery:</strong> Available in select areas for orders placed before 12 PM</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Delivery Fees</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Standard delivery:</strong> $4.99 (free for orders over $50)</li>
              <li><strong>Express delivery:</strong> $9.99</li>
              <li><strong>Same-day delivery:</strong> $14.99</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Order Tracking</h2>
            <p className="text-gray-700">
              Once your order is shipped, you will receive a confirmation email with a tracking number 
              that allows you to monitor your delivery in real-time.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Delivery Issues</h2>
            <p className="text-gray-700 mb-4">
              If you encounter any issues with your delivery, please contact our customer service 
              team within 24 hours of your scheduled delivery time.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
              <p className="text-blue-700">
                <strong>Contact Support:</strong> For delivery-related inquiries, please call our customer service at 
                <a href="tel:+1234567890" className="font-semibold ml-1">+91-8008954694</a> or email 
                <a href="mailto:support@ressde.in" className="font-semibold ml-1">support@ressde.in</a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPolicy;